import { documentoV2Schema } from './document.type'
import { phoneSchema } from './phone.type'
import { z } from 'zod'
import { realNameFieldSchema } from 'utils/schema.util'
import { naturalPersonAddressSchema } from './address.type'
import { isFilled, validateDocumentsV2, validatePhones } from 'utils/validate.util'
import dayjs from 'dayjs'

export const naturalPersonSchema = z
  .object({
    id: z.number().nullish(),
    nome: realNameFieldSchema.nullish(),
    nomeSocial: realNameFieldSchema.nullish(),
    dataNascimento: z.string().nullish(),
    idade: z.number().nullish(),
    nomeMae: realNameFieldSchema.nullish(),
    nomePai: realNameFieldSchema.nullish(),
    genero: z
      .object({
        id: z.number().nullish(),
        nome: z.string().nullish(),
      })
      .nullish(),
    corPele: z
      .object({
        id: z.number().nullish(),
        nome: z.string().nullish(),
      })
      .nullish(),
    enderecos: z.array(naturalPersonAddressSchema),
    telefones: z.array(phoneSchema).transform((fields) => {
      return validatePhones(fields)
    }),
    documentos: z.array(documentoV2Schema).transform((fields) => {
      return validateDocumentsV2(fields)
    }),
  })
  .superRefine((pessoa, ctx) => {
    if (isFilled(pessoa.dataNascimento)) {
      const diffYears = dayjs(dayjs()).diff(pessoa.dataNascimento, 'year')
      if (diffYears < 12) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Data de nascimento informada não pode ser inferior há 12 anos.',
          path: ['dataNascimento'],
        })
      }
    }
  })

export type NaturalPersonType = z.infer<typeof naturalPersonSchema>

export const NaturalPersonInit: NaturalPersonType = {
  telefones: [],
  documentos: [],
  enderecos: [],
}
